if (!customElements.get('component-similar-loved-styles')) {
    customElements.define('component-similar-loved-styles', class SimilarLovedStyles extends HTMLElement {
        constructor() {
            super();

            this.props = {
                productId: this.dataset.productId,
                intent: this.dataset.intent
            }
        }

        connectedCallback() {
            this.fetchRecommendations(this.props.productId);
            this.initializeSliderControls();
        }

        initializeSliderControls() {
            setTimeout(() => {
                this.setupSliderControls();
            }, 100);
        }

        setupSliderControls() {
            const slider = this.querySelector('.js-slider');
            const prevBtn = this.querySelector('.js-prev');
            const nextBtn = this.querySelector('.js-next');
            
            if (!slider || !prevBtn || !nextBtn) return;

            prevBtn.addEventListener("click", () => {
                slider.scrollBy({ top: 0, left: -325, behavior: 'smooth' });
                
                setTimeout(() => {
                    const currentScroll = slider.scrollLeft;
                    if (currentScroll > 0 && currentScroll <= 100) {
                        slider.scrollBy({ top: 0, left: -currentScroll, behavior: 'smooth' });
                    }
                }, 50);
            });

            nextBtn.addEventListener("click", () => {
                slider.scrollBy({ top: 0, left: 325, behavior: 'smooth' });
                
                setTimeout(() => {
                    const maxScroll = slider.scrollWidth - slider.offsetWidth;
                    const currentScroll = slider.scrollLeft;
                    const remainingScroll = maxScroll - currentScroll;
                    if (remainingScroll > 0 && remainingScroll <= 100) {
                        slider.scrollBy({ top: 0, left: remainingScroll, behavior: 'smooth' });
                    }
                }, 50);
            });

            slider.addEventListener('scroll', () => {
                if (slider.scrollLeft > 0) {
                    prevBtn.classList.remove('btn--disabled');
                } else {
                    prevBtn.classList.add('btn--disabled');
                }

                if (slider.scrollLeft < (slider.scrollWidth - slider.offsetWidth - 10)) {
                    nextBtn.classList.remove('btn--disabled');
                } else {
                    nextBtn.classList.add('btn--disabled');
                }
            });

            this.updateButtonStates();
        }

        updateButtonStates() {
            const slider = this.querySelector('.js-slider');
            const prevBtn = this.querySelector('.js-prev');
            const nextBtn = this.querySelector('.js-next');
            
            if (!slider || !prevBtn || !nextBtn) return;

            if (slider.scrollLeft <= 0) {
                prevBtn.classList.add('btn--disabled');
            } else {
                prevBtn.classList.remove('btn--disabled');
            }

            if (slider.scrollLeft >= (slider.scrollWidth - slider.offsetWidth - 10)) {
                nextBtn.classList.add('btn--disabled');
            } else {
                nextBtn.classList.remove('btn--disabled');
            }
        }

        fetchRecommendations(productId) {
            const productRecommendationsSection = this.querySelector('.js-template');
            fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&section_id=similar-loved-styles&intent=related`)
            .then(response => response.text())
            .then((text) => {
                if (text) {
                  productRecommendationsSection.innerHTML = text;
                  this.classList.remove('hidden');
                  setTimeout(() => {
                    this.setupSliderControls();
                  }, 100);
                } else {
                  this.classList.add('hidden');
                }
            }).catch((error) => {
              console.error(error);
              this.classList.add('hidden');
            });
          }
    });
}

if (!customElements.get('component-similar-loved-styles-product')) {
    customElements.define('component-similar-loved-styles-product', class SimilarLovedStylesProduct extends HTMLElement {
        constructor() {
            super();

            this.state = {
                product: '',
                response: '',
                trueSize: '',
                selectedVariantId: null,
                selectedVariant: null
            }

            this.props = {
                url: this.dataset.url,
                productHandle: this.dataset.productHandle,
                id: this.dataset.productId || this.componentId
            }

        // Get the height of the image in the img-container, if present
        const imgContainer = this.querySelector('.img-container img');
        this.imgHeight = imgContainer ? imgContainer.naturalHeight || imgContainer.height : null;
        }

        
        connectedCallback() {
            this.renderSimilarLovedStyles();
        }

        async renderSimilarLovedStyles() {
            const response = await fetch(`${this.props.url}${this.props.url.includes('?') ? '&' : '?'}view=complete-the-look-json&currency=${window.Shopify.currency.active}&country=${window.Shopify.country}`, {
                method: "get"
            });
            if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
            }
            this.state.response = await response.json();
            this.state.product = await this.getProduct();

            this.renderColors();

            this.handleColorSwatchChange();

            this.selectFirstColor();
        }

        selectFirstColor() {
          const options = this.querySelectorAll('.js-colors .js-color');
          if (options.length > 0) {
            options[0].classList.add('selected');
          }
        }

        async getProduct() {
            let response = await fetch(`${window.Shopify.routes.root}products/${this.props.productHandle}?view=collection-grid-json`, {
              method: "get"
            });
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            response = await response.json();
            return response;
          }


    async renderColors() {
        if (this.state.product?.colors && Object.keys(this.state.product.colors).length > 0) {

          for (const color in this.state.product.colors) {
            let showColorSwatch = false;
            let hasAvailableSize;
            let availableSize;
            if (this.props.sizeType === 'formFit' && this.props.formFitSize) {
              hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.formFitSize));
              availableSize = this.props.formFitSize;
            } else if (this.props.sizeType === 'alpha' && this.props.alphaSize) {
              hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.alphaSize));
              availableSize = this.props.alphaSize;
            } else if (this.props.sizeType === 'bra' && this.props.braSize) {
              const range = this.getRange(this.props.braSize);
              hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.braSize) || el.includes(range));
              availableSize = this.props.braSize;
            } else {
              showColorSwatch = true;
            }
            if (hasAvailableSize) {
              this.state.availableSize = availableSize;
              showColorSwatch = true;
            }
            if (showColorSwatch) {
              const colorTemplate = this.querySelector('.js-template-color').content.cloneNode(true);
              if (window.theme.colors[color]) {
                if (window.theme.colors[color].image) {
                  colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', `url(${window.theme.colors[color].image}`);
                }
                colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
                colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
              }
              if (color === this.props.color) {
                colorTemplate.querySelector('.js-input').checked = true;
                colorTemplate.querySelector('.js-color').classList.add("first");
              }
              colorTemplate.querySelector('.js-label').setAttribute('for', `color_${color}_${this.props.id}`);
              colorTemplate.querySelector('.js-label').dataset.color = color;
              colorTemplate.querySelector('.js-input').value = color;
              colorTemplate.querySelector('.js-input').id = `color_${color}_${this.props.id}`;
              this.querySelector('.js-colors').appendChild(colorTemplate);
            }
            this.querySelector('.js-colors').classList.add('opacity-1');
          }
        } else {
          this.querySelector('.js-colors').classList.remove('colors');
        }
      }
  
      handleColorSwatchChange() {
        const self = this;
        this.querySelectorAll('.js-colors .js-input').forEach(color => {
          color.addEventListener('change', () => {
            self.querySelectorAll('.js-colors .js-color').forEach(option => {
              option.classList.remove('selected');
            });
            color.closest('.js-color').classList.add('selected');
            
            self.state.siblingProduct = self.state.product.colors[color.value];
            self.querySelectorAll('.js-link').forEach(link => {
              if (self.state.availableSize) {
                link.href = `${self.state.siblingProduct.url}${self.state.siblingProduct.url.includes('?') ? '&' : '?'}size=${self.state.availableSize}`;
              } else {
                link.href = self.state.siblingProduct.url;
              }
            });
            let img;
            img = self.state.siblingProduct.images[0].src;
            self.renderImages(img);
            this.state.response.availableSizes = self.state.siblingProduct.availableSizes;
            this.renderSizes();
            const sizeSelect = self.querySelector('.js-sizes');
            if (sizeSelect && sizeSelect.options.length > 0) {
              sizeSelect.selectedIndex = 0;
            }
  
          const productUrl = self.state.product.colors[color.value].url;
  
          fetch(`${productUrl}.js`)
            .then(response => response.json())
            .then(data => {
            const variantsArray = data.variants;
            const newVariants = {};
            variantsArray.forEach(variant => {
              const key = variant.option2;
              newVariants[key] = {
                id: variant.id,
                sku: variant.sku,
                price: variant.price,
                compare_at_price: variant.compare_at_price
              };
            });
            this.state.response.variants = newVariants;
            })
            .catch(error => {
              console.error('Error to get product:', error);
            });
          });
        });
        this.querySelectorAll('.js-colors .js-label').forEach(color => {
          color.addEventListener('mouseover', () => {
            self.preloadImg(color.dataset.color, 0);
            self.preloadImg(color.dataset.color, 1);
          });
        });
      }
  
      preloadImg(color, imgIndex) {
        const newImage = this.state.product.colors[color].images[imgIndex];
        if (newImage) {
          const preloadImg = this.querySelector('.js-img').cloneNode();
          preloadImg.src = newImage.src;
          preloadImg.srcset = getSrcset(newImage.src, this.props.defaultImgSize);
        }
      }
  
      renderImages(img) {
        if (img) {
          this.querySelector('.js-featured-product-img').classList.add('lazyloading');
          this.querySelector('.js-featured-product-img').dataset.src = img;
          this.querySelector('.js-featured-product-img').dataset.srcset = getSrcset(img, this.props.defaultImgSize);
          this.querySelector('.js-featured-product-img').classList.add('lazyload');
        }
      }
    });
}